import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/pcApi";
import { CONTENT_TYPE_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";
import { formateColumnFilter } from "@/utils/columnFilter";
import ContentTypeForm from "./ContentTypeForm";
import { getAllContentTypes } from "../../CMSSlice";
import "react-toastify/dist/ReactToastify.css";

const ContentType = () => {
  const [contentTypeDetails, setContentTypeDetails] = useState();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteContentType, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getContentTypeRecords,
    {
      data: contentTypeList,
      isError: isContentTypeError,
      isLoading: isContentTypeLoading,
      isFetching: isContentTypeFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Name",
      accessor: "Name",
      filter: true,
    },
    {
      Header: "Description",
      accessor: "Description",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
    {
      Header: "ContentObject",
      accessor: "ContentObject",
      filter: true,
      Cell: ({ value }) => {
        let contentKeys = "";
        if (value) {
          try {
            var contentObject = JSON.parse(value);
            for (const key in contentObject) {
              contentKeys += key + " | ";
            }
          } catch (error) { }
        }
        return value ? contentKeys.slice(0, -2) : "-";
      },
    },
  ];

  const handleEditData = (contentTypeData) => {
    setSelectedRecord(contentTypeData);
    setIsAddModalOpen(true);
  };

  const handleDelete = () => {
    deleteContentType({
      entity: "CMSReference/ContentType",
      id: selectedRecord.Id,
      tag: CONTENT_TYPE_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsDeleteModalOpen(!isDeleteModalOpen);
        successToast("Content-type deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );
    getContentTypeRecords({
      entity: "CMSReference/ContentTypes",
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: CONTENT_TYPE_TAG,
    });
    setContentTypeDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !isContentTypeLoading &&
      !isContentTypeError &&
      contentTypeList &&
      !isContentTypeFetching
    ) {
      dispatch(getAllContentTypes(contentTypeList.value));
      let contentTypeData = [...contentTypeList.value];
      setContentTypeDetails({
        ...contentTypeDetails,
        tableRowsData: contentTypeList.value ? contentTypeData : [],
        totalData:
          contentTypeList && contentTypeList["@odata.count"]
            ? contentTypeList["@odata.count"]
            : 0,
        onEditClick: (data) => handleEditData(data),
        onDeleteClick: (data) => {
          setIsDeleteModalOpen(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [
    isContentTypeError,
    contentTypeList,
    isContentTypeLoading,
    isContentTypeFetching,
  ]);

  return (
    <Container>
      <Row>
        {contentTypeDetails && (
          <DataReactTable
            reactTableData={contentTypeDetails}
            onAddClick={() => {
              setIsAddModalOpen(true);
              setSelectedRecord();
            }}
            title="Content Type"
            isFetching={isContentTypeFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isAddModalOpen && (
        <AddModal
          toggle={() => setIsAddModalOpen(!isAddModalOpen)}
          color="success"
          xxl
          title={`${selectedRecord ? "Edit" : "Add"} Content Type`}
          header
          btn="Success"
          message={
            <ContentTypeForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsAddModalOpen={setIsAddModalOpen}
            />
          }
        />
      )}
      {isDeleteModalOpen && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.Name}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default ContentType;
